import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />

      {/* Hero Section */}
      <section style={{
        position: 'relative',
        width: '100%',
        height: '550px',
        background: '#1C46BE',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        margin: '0 auto'
      }}>
        <div style={{
          width: '100%',
          maxWidth: '1280px',
          height: '550px',
          margin: '0 auto',
          padding: '20px 20px 20px 20px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '15px'
        }}>
          <div style={{
            textAlign: 'center',
            color: 'white',
            maxWidth: '800px',
            zIndex: 2
          }}>
            {/* Privacy Icon */}
            <div style={{ marginBottom: '30px' }}>
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" style={{ margin: '0 auto' }}>
                <circle cx="40" cy="40" r="35" fill="none" stroke="white" strokeWidth="3"/>
                <path d="M40 15 L55 25 L55 45 C55 55 40 65 40 65 C40 65 25 55 25 45 L25 25 Z" fill="none" stroke="white" strokeWidth="3"/>
                <path d="M32 40 L37 45 L48 34" stroke="white" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            <h1 style={{
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
              fontSize: '48px',
              fontWeight: 'bold',
              lineHeight: '120%',
              letterSpacing: '-2%',
              color: '#F8F9FA',
              margin: '0 auto 16px auto'
            }}>
              Privacy Policy
            </h1>

            <p style={{
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '140%',
              letterSpacing: '0%',
              color: '#F8F9FA',
              margin: '0 auto 12px auto',
              maxWidth: '600px'
            }}>
              Your privacy and data protection are fundamental to our business.
            </p>
            <p style={{
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
              fontSize: '18px',
              fontWeight: '400',
              lineHeight: '140%',
              letterSpacing: '0%',
              color: '#F8F9FA',
              margin: '0 auto 32px auto',
              maxWidth: '600px'
            }}>
              Learn how we collect, use, and protect your information.
            </p>
          </div>
        </div>

        {/* Background Wave */}
        <div style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          height: '120px',
          zIndex: 1
        }}>
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ width: '100%', height: '100%', display: 'block' }}>
            <path d="M0,60 C400,120 600,10 800,20 C1000,20 1100,35 1200,60 L1200,120 L0,120 Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <main style={{ flex: 1, background: '#ffffff', padding: '60px 0 80px 0' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>

          {/* Last Updated */}
          <div style={{
            background: '#f8f9fa',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '40px',
            border: '1px solid #e5e7eb'
          }}>
            <p style={{
              margin: '0',
              fontSize: '14px',
              color: '#666',
              fontWeight: '600'
            }}>
              <strong>Last Updated:</strong> September 30, 2025
            </p>
          </div>

          {/* Introduction */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              1. Introduction
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              SortMyBusinessWithAI ("we," "our," or "us") is committed to protecting your privacy and personal data. This Privacy Policy explains how we collect, use, process, and safeguard your information when you use our AI-powered business automation platform and related services.
            </p>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              As an Irish company, we comply with the General Data Protection Regulation (GDPR) and Irish data protection laws. This policy applies to all users of our platform, regardless of location.
            </p>
            <div style={{
              background: '#e8f0fe',
              padding: '16px',
              borderRadius: '6px',
              border: '1px solid #4169E1'
            }}>
              <p style={{
                margin: '0',
                fontSize: '14px',
                color: '#1a1a1a'
              }}>
                <strong>Data Controller:</strong> SortMyBusinessWithAI, Ireland<br/>
                <strong>Contact:</strong> info@sortmybusinesswithai.ie<br/>
                <strong>Phone:</strong> +353 87 2526280
              </p>
            </div>
          </section>

          {/* Information We Collect */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              2. Information We Collect
            </h2>

            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '16px'
            }}>
              2.1 Personal Information
            </h3>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li>Full name and contact details (email address, phone number)</li>
              <li>Country of residence</li>
              <li>Account credentials (username, encrypted password)</li>
              <li>Profile information and preferences</li>
            </ul>

            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '16px'
            }}>
              2.2 Business Data
            </h3>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li><strong>Customer Information:</strong> Names, contact details, addresses, VAT status</li>
              <li><strong>Product/Material Data:</strong> Names, descriptions, pricing, inventory levels</li>
              <li><strong>Job Costing Data:</strong> Project details, labor costs, material usage</li>
              <li><strong>Staff Information:</strong> Employee names, roles, contact details, hourly rates</li>
              <li><strong>Financial Data:</strong> Quotes, invoices, cost tracking, payment terms</li>
            </ul>

            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '16px'
            }}>
              2.3 Technical Information
            </h3>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li>Access logs and system usage data</li>
              <li>API integration data and sync logs</li>
              <li>Device and browser information</li>
              <li>IP addresses and session data</li>
              <li>Google Analytics data (website usage, page views, user behavior)</li>
            </ul>
          </section>

          {/* How We Use Your Information */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              3. How We Use Your Information
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              We process your personal data for the following purposes under GDPR Article 6:
            </p>

            <div style={{ marginBottom: '20px' }}>
              <h4 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#1a1a1a',
                marginBottom: '8px'
              }}>
                Contract Performance (Article 6(1)(b)):
              </h4>
              <ul style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.6',
                marginBottom: '16px',
                paddingLeft: '20px'
              }}>
                <li>Provide access to our AI business automation platform</li>
                <li>Process and store your business data</li>
                <li>Enable customer, product, and job management features</li>
                <li>Generate reports, quotes, and invoices</li>
                <li>Facilitate system integrations (Sort My Books, Power BI)</li>
              </ul>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <h4 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#1a1a1a',
                marginBottom: '8px'
              }}>
                Legitimate Interest (Article 6(1)(f)):
              </h4>
              <ul style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.6',
                marginBottom: '16px',
                paddingLeft: '20px'
              }}>
                <li>Improve and optimize our services</li>
                <li>Provide customer support and troubleshooting</li>
                <li>Ensure system security and prevent fraud</li>
                <li>Analyze usage patterns for service enhancement</li>
              </ul>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <h4 style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#1a1a1a',
                marginBottom: '8px'
              }}>
                Consent (Article 6(1)(a)):
              </h4>
              <ul style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.6',
                marginBottom: '16px',
                paddingLeft: '20px'
              }}>
                <li>Send marketing communications (where applicable)</li>
                <li>Process optional data you choose to provide</li>
              </ul>
            </div>
          </section>

          {/* Data Sharing and Transfers */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              4. Data Sharing and International Transfers
            </h2>

            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '16px'
            }}>
              4.1 Service Providers
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              We may share your data with trusted service providers who assist us in operating our platform:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li><strong>AWS (Amazon Web Services):</strong> Cloud hosting and database services</li>
              <li><strong>Email Service Providers:</strong> For system notifications and communications</li>
              <li><strong>Google Analytics:</strong> Website analytics and user behavior tracking</li>
              <li><strong>Integration Partners:</strong> Sort My Books and other business software integrations</li>
            </ul>

            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '16px'
            }}>
              4.2 International Transfers
            </h3>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              Some of our service providers are located outside the European Economic Area (EEA). We ensure adequate protection through:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li>Standard Contractual Clauses (SCCs) approved by the European Commission</li>
              <li>Adequacy decisions where applicable</li>
              <li>Appropriate technical and organizational security measures</li>
            </ul>
          </section>

          {/* Data Security */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              5. Data Security
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              We implement robust security measures to protect your personal data:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li><strong>Encryption:</strong> Data encrypted in transit and at rest</li>
              <li><strong>Access Controls:</strong> Role-based access with multi-factor authentication</li>
              <li><strong>Password Security:</strong> Bcrypt hashing for all user passwords</li>
              <li><strong>Rate Limiting:</strong> Maximum 10 login attempts per hour to prevent brute force attacks</li>
              <li><strong>Session Security:</strong> Automatic logout after 15 minutes of inactivity</li>
              <li><strong>Regular Security Audits:</strong> Ongoing monitoring and vulnerability assessments</li>
              <li><strong>Secure Infrastructure:</strong> AWS enterprise-grade security standards</li>
            </ul>
          </section>

          {/* Data Retention */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              6. Data Retention
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              We retain your personal data only as long as necessary for the purposes outlined in this policy:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li><strong>Account Data:</strong> Retained while your account remains active</li>
              <li><strong>Business Records:</strong> Retained for legal and accounting requirements (typically 7 years)</li>
              <li><strong>System Logs:</strong> Retained as necessary for security and debugging purposes</li>
              <li><strong>Inactive Accounts:</strong> Data may be deleted after extended periods of inactivity with prior notice</li>
            </ul>
          </section>

          {/* Your Rights Under GDPR */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              7. Your Rights Under GDPR
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              As a data subject, you have the following rights regarding your personal data:
            </p>

            <div style={{
              background: '#f8f9fa',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <ul style={{
                fontSize: '16px',
                color: '#666',
                lineHeight: '1.6',
                margin: '0',
                paddingLeft: '20px'
              }}>
                <li><strong>Right of Access (Article 15):</strong> Request copies of your personal data</li>
                <li><strong>Right to Rectification (Article 16):</strong> Correct inaccurate or incomplete data</li>
                <li><strong>Right to Erasure (Article 17):</strong> Request deletion of your personal data</li>
                <li><strong>Right to Restrict Processing (Article 18):</strong> Limit how we use your data</li>
                <li><strong>Right to Data Portability (Article 20):</strong> Receive your data in a machine-readable format</li>
                <li><strong>Right to Object (Article 21):</strong> Object to processing based on legitimate interests</li>
                <li><strong>Right to Withdraw Consent:</strong> Where processing is based on consent</li>
              </ul>
            </div>

            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              To exercise any of these rights, please contact us at <strong>info@sortmybusinesswithai.ie</strong> or call <strong>+353 87 2526280</strong>. We will respond within 30 days of receiving your request.
            </p>
          </section>

          {/* Cookies and Tracking */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              8. Cookies and Tracking
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              Our platform uses minimal cookies and tracking:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li><strong>Essential Cookies:</strong> Required for platform functionality and user authentication</li>
              <li><strong>Session Tokens:</strong> JWT tokens stored in browser localStorage to maintain your login session (expires after 15 minutes of inactivity)</li>
              <li><strong>Security Measures:</strong> Rate limiting data (10 login attempts per hour maximum)</li>
              <li><strong>Google Analytics:</strong> We use Google Analytics to understand website usage and improve our services</li>
              <li><strong>Analytics Cookies:</strong> Track page views, user interactions, and website performance</li>
            </ul>
          </section>

          {/* Changes to This Policy */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              9. Changes to This Privacy Policy
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              We may update this Privacy Policy from time to time to reflect changes in our practices or for legal, operational, or regulatory reasons. We will notify you of any material changes by:
            </p>
            <ul style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '20px',
              paddingLeft: '20px'
            }}>
              <li>Posting the updated policy on our website</li>
              <li>Sending email notifications for significant changes</li>
              <li>Updating the "Last Updated" date at the top of this policy</li>
            </ul>
          </section>

          {/* Contact Information */}
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: '700',
              color: '#1a1a1a',
              marginBottom: '20px'
            }}>
              10. Contact Us
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '16px'
            }}>
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>

            <div style={{
              background: '#e8f0fe',
              padding: '24px',
              borderRadius: '8px',
              border: '1px solid #4169E1'
            }}>
              <p style={{
                margin: '0 0 12px 0',
                fontSize: '16px',
                color: '#1a1a1a',
                fontWeight: '600'
              }}>
                SortMyBusinessWithAI
              </p>
              <p style={{
                margin: '0 0 8px 0',
                fontSize: '16px',
                color: '#1a1a1a'
              }}>
                <strong>Email:</strong> info@sortmybusinesswithai.ie
              </p>
              <p style={{
                margin: '0 0 8px 0',
                fontSize: '16px',
                color: '#1a1a1a'
              }}>
                <strong>Phone:</strong> +353 87 2526280
              </p>
              <p style={{
                margin: '0 0 16px 0',
                fontSize: '16px',
                color: '#1a1a1a'
              }}>
                <strong>Address:</strong> Ireland
              </p>
              <p style={{
                margin: '0',
                fontSize: '14px',
                color: '#666'
              }}>
                You also have the right to lodge a complaint with the Irish Data Protection Commission (DPC) if you believe your data protection rights have been violated.
              </p>
            </div>
          </section>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;